var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandsFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "67px",
    viewBox: "0 0 55 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C9C7024A-3060-469F-BB8D-B5015F7DFA81") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.-Key-Facts-about-Hana",
    transform: "translate(-922.000000, -418.000000)",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(924.000000, 420.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.204208,12.794416 C11.098448,5.480976 17.742608,0.080016 25.648368,0.080016 C33.505488,0.080016 40.116528,5.414736 42.057008,12.659696",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.170384,33.613088 L45.170384,22.264448 C45.158384,20.381248 46.384944,18.830368 48.080944,18.8192916 C49.773744,18.810688 51.169264,20.342848 51.181264,22.227648 L51.181264,44.256288 L41.081264,57.444448 C41.081264,57.444448 39.986384,58.720448 40.310864,63.387808",
    id: "Stroke-3",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.22608,63.497152 L28.23808,53.261312 C28.23808,49.284832 32.87552,46.591232 32.87552,46.591232 C34.97472,45.185472 37.36432,42.736032 37.36432,42.736032 L41.32208,38.445312 C42.95328,36.678272 45.3088,36.171872 46.55568,37.320512 C47.80432,38.469152 47.49008,40.854592 45.85872,42.621632 L40.29552,48.646912",
    id: "Stroke-5",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.092496,33.613088 L6.090896,22.264448 C6.102736,20.381248 4.876336,18.830368 3.180176,18.8192916 C1.487536,18.810688 0.092016,20.342848 0.080016,22.227648 L0.081776,44.256288 L10.180016,57.444448 C10.180016,57.444448 11.274896,58.720448 10.950416,63.387808",
    id: "Stroke-7",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.035216,63.497152 L23.023216,53.261312 C23.023216,49.284832 18.385776,46.591232 18.385776,46.591232 C16.286416,45.185472 13.898576,42.736032 13.898576,42.736032 L9.939216,38.445312 C8.309616,36.678272 5.954096,36.171872 4.705456,37.320512 C3.458576,38.469152 3.772976,40.854592 5.404176,42.621632 L10.967376,48.646912",
    id: "Stroke-9",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.079824,24.196912 L18.597104,24.634672 C18.597104,24.634672 15.575664,25.210832 15.288304,27.440272 L14.834544,35.263472",
    id: "Stroke-11",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.171392,24.196912 L32.664352,24.667632 C32.664352,24.667632 35.686112,25.243952 35.973632,27.474512 L36.426752,35.262192",
    id: "Stroke-13",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.427952,21.3612 L32.427952,16.61896 C32.330192,8.9732 25.620112,9.4876 25.620112,9.4876 C25.620112,9.4876 18.909872,8.9732 18.812112,16.61896 L18.812112,21.3612",
    id: "Stroke-15",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85928,16.9648 C21.85928,19.9248 23.65032,22.9272 25.6684,22.9272 C27.70936,22.9272 29.25992,19.9248 29.25992,16.9648 C29.25992,16.9648 29.37304,15.01696 28.38152,13.74736 C28.38152,13.74736 25.77912,16.47168 19.06728,16.84864",
    id: "Stroke-17",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-19",
    stroke: "#ED7330",
    points: "21.079824 24.196912 25.621104 32.174992 30.171344 24.196912"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsFace);
export default __webpack_public_path__ + "static/media/handsFace.e64b9c60.svg";
export { ForwardRef as ReactComponent };